var styleDataHash = "be33654a";
const injectCss = () => {
  var css = `._24xB7,.glob_fontElementMap{font-family:var(--ricos-font-family,unset)}.X-SLS,._611NI{height:386px;overflow:auto}[dir] .X-SLS,[dir] ._611NI{margin-top:20px}[dir=ltr] .X-SLS,[dir=ltr] ._611NI{margin-right:-16px;padding-right:16px}[dir=rtl] .X-SLS,[dir=rtl] ._611NI{margin-left:-16px;padding-left:16px}.X-SLS.a9wH3,._611NI.a9wH3{height:calc(100vh - 190px)}._0PMZd{display:flex;flex-direction:column}[dir=ltr] .EpfZL{float:right;text-align:right}[dir=rtl] .EpfZL{float:left;text-align:left}[dir] .sZDfe{cursor:pointer}.m0cHC{align-items:center;display:flex;height:100%;justify-content:center;width:100%}[dir] .m0cHC{margin-top:50px}._1i6Dl{height:100%;width:100%}.X-SLS,._1i6Dl{align-items:center;display:flex;justify-content:center}.X-SLS{max-width:100%}.wA3i2{--wds-input-value-font-size-medium:14px}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
};
injectCss();
var giphy_selector_default = {
  "fontElementMap": "_24xB7",
  "giphy_selector_infinite_scroll_container": "_611NI",
  "giphySelectorErrorContainer": "X-SLS",
  "mobile": "a9wH3",
  "giphy_selector_infinite_scroll": "_0PMZd",
  "giphy_selector_powerdByGiphy": "EpfZL",
  "giphy_selector_gif_img_container": "sZDfe",
  "giphy_selector_spinner_load_more": "m0cHC",
  "giphy_selector_spinner_empty_modal": "_1i6Dl",
  "searchInput": "wA3i2"
};
export {
  giphy_selector_default as default,
  injectCss
};
//# sourceMappingURL=giphy-selector-scss.js.map
